import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MessageModule} from 'ng-design-system';
import {SafePipeModule} from '../pipes/safeResourceUrl/safeResourceUrl.module';
import {ContactCtaComponent} from './contact-cta.component';
import {ContactIframeComponent} from './contact-iframe/contact-iframe.component';

@NgModule({
  declarations: [
    ContactCtaComponent,
    ContactIframeComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    MessageModule,
    SafePipeModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ContactCtaComponent: {
          component: ContactCtaComponent,
        }
      }
    })
  ],
  exports: [
    ContactCtaComponent,
    ContactIframeComponent
  ]
})
export class ContactCtaModule {
}
